import PropTypes from 'prop-types';
import React from 'react';

import useLocation from '../../hooks/use_location';
import LocationItem from './item';

const Location = ({
	exclude_groups,
	exclude_locations,
	include_groups,
	include_locations,
}) => {
	const { items: locations } = useLocation({
		exclude_groups,
		exclude_locations,
		include_groups,
		include_locations,
	});

	return (
		<>
			{locations.map((location, index) => {
				return (
					<LocationItem
						address={location.address}
						city={location.city}
						className={locations?.length != index + 1 ? 'border-bottom' : ''}
						groups={location.groups}
						key={index}
						location_id={location.location_id}
						location_settings={location.location_settings}
						subtitle={location.location_variant.subtitle}
						title={location.location_variant.title}
						zip_code={location.zip_code}
					/>
				);
			})}
		</>
	);
};

Location.propTypes = {
	exclude_groups: PropTypes.array,
	exclude_locations: PropTypes.array,
	include_groups: PropTypes.array,
	include_locations: PropTypes.array,
};

export default Location;
